'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = numberValidator;
function numberValidator(_ref) {
  var gt = _ref.gt,
      gte = _ref.gte,
      lt = _ref.lt,
      lte = _ref.lte,
      exact = _ref.exact,
      divisibleBy = _ref.divisibleBy,
      integer = _ref.integer,
      message = _ref.message;

  if (typeof exact === 'number') {
    return function (input) {
      if (input !== exact) {
        return message || 'must be exactly ' + String(exact);
      }
    };
  } else {
    return function (input) {
      if (typeof input !== 'number' || isNaN(input)) {
        return message || 'must be a valid number';
      } else if (typeof gt === 'number' && input <= gt) {
        return message || 'must be greater than ' + String(gt);
      } else if (typeof gte === 'number' && input < gte) {
        return message || 'must be greater than or equal to ' + String(gte);
      } else if (typeof lt === 'number' && input >= lt) {
        return message || 'must be less than ' + String(lt);
      } else if (typeof lte === 'number' && input > lte) {
        return message || 'must be less than or equal to ' + String(lte);
      } else if (typeof divisibleBy === 'number' && input % divisibleBy !== 0) {
        return message || 'must be divisible by ' + String(divisibleBy);
      } else if (integer && Math.floor(input) !== input) {
        return message || 'must be an integer';
      }
    };
  }
}


//////////////////
// WEBPACK FOOTER
// ../flow-runtime-validators/lib/number.js
// module id = 296
// module chunks = 0